import React, { useState } from 'react';

import { AritoForm, AritoHeaderTabs, AritoIcon, BottomActionBarV2, AritoDialog } from '@/components/custom/erp';
import type { SoQuyTienMatSearchFormValues, TaiKhoan } from '@/types/schemas';
import { initialValues, SearchFormValues, searchSchema } from '../schemas';
import { DetailTab, OtherTab } from './tabs';
import BasicInfo from './tabs/BasicInfoTab';

interface InitialSearchDialogProps {
  open: boolean;
  onClose: () => void;
  onSearch: (values: SoQuyTienMatSearchFormValues) => void;
}

const InitialSearchDialog: React.FC<InitialSearchDialogProps> = ({ open, onClose, onSearch }) => {
  const [taiKhoan, setTaiKhoan] = useState<TaiKhoan>();

  const handleSubmit = (data: SearchFormValues) => {
    onSearch({
      ...data,
      tk: taiKhoan || null
    });
  };

  return (
    <AritoDialog
      open={open}
      onClose={onClose}
      title='Sổ quỹ tiền mặt'
      maxWidth='lg'
      disableBackdropClose={false}
      disableEscapeKeyDown={false}
      titleIcon={<AritoIcon icon={12} />}
    >
      <AritoForm
        mode='add'
        hasAritoActionBar={false}
        schema={searchSchema}
        initialData={initialValues}
        onSubmit={data => {
          handleSubmit(data);
        }}
        className='w-full'
        headerFields={
          <div className='max-h-[calc(100vh-150px)] w-[800px] min-w-[800px] overflow-y-auto'>
            <BasicInfo setTaiKhoan={setTaiKhoan} />

            <AritoHeaderTabs
              tabs={[
                {
                  id: 'details',
                  label: 'Chi tiết',
                  component: <DetailTab />
                },
                {
                  id: 'other',
                  label: 'Khác',
                  component: <OtherTab />
                }
              ]}
            />
          </div>
        }
        bottomBar={<BottomActionBarV2 onClose={onClose} mode='search' />}
      />
    </AritoDialog>
  );
};

export default InitialSearchDialog;
